import ClientApiBase from "api/client/client-api.base";

export default class StampApi extends ClientApiBase {
	scanStamp = async (id) => {
		return await this.axios.get("/scan/" + id);
	};

	getScannedStamps = async () => {
		return await this.axios.get("/member-scan");
	};
}
